import i18n from 'i18n/config';
import { useEffect, useState } from 'react';

import { SelectorOption } from 'types';

import { SingleValue } from 'react-select';
import boardsAttendanceTypes from 'modules/boards/constants/boardsAttendanceTypes';

type UseGetAttendanceTypeOptionsProps = {
  attendanceType?: string;
};

export const useGetAttendanceTypeOptions = ({
  attendanceType,
}: UseGetAttendanceTypeOptionsProps) => {
  const [attendanceTypeOptions, setAttendanceTypeOptions] = useState<
    SelectorOption[]
  >([]);
  const [selectedAttendanceType, setSelectedAttendanceType] =
    useState<string>('');
  const [selectedAttendanceTypeOption, setSelectedAttendanceTypeOption] =
    useState<SelectorOption | null>(null);

  const handleChangeAttendanceType = (option: SingleValue<SelectorOption>) => {
    if (option) {
      setSelectedAttendanceType(option.value);
      setSelectedAttendanceTypeOption(option);
    }
  };

  useEffect(() => {
    const attendanceTypes: SelectorOption[] = boardsAttendanceTypes.map(
      (attendanceType) => ({
        value: attendanceType.value,
        label: i18n.t(attendanceType.label),
      })
    );

    if (attendanceType) {
      const selectedOption = attendanceTypes.find(
        (option) => option.value === attendanceType
      );
      setSelectedAttendanceType(attendanceType);
      setSelectedAttendanceTypeOption(selectedOption || null);
    } else {
      const defaultOption = attendanceTypes.find(
        (option) => option.value === boardsAttendanceTypes[0].value
      );
      setSelectedAttendanceType(boardsAttendanceTypes[0].value);
      setSelectedAttendanceTypeOption(defaultOption || null);
    }

    setAttendanceTypeOptions(attendanceTypes);
  }, [i18n.language]);

  return {
    data: {
      attendanceTypeOptions,
      selectedAttendanceType,
      selectedAttendanceTypeOption,
    },
    actions: {
      handleChangeAttendanceType,
    },
  };
};
